export default "__VITE_ASSET__df766295__"